import {combineReducers} from 'redux';
import {router5Reducer} from 'redux-router5';

import tax from './taxReducer';
import user from './userReducer';
import units from './unitsReducer';
import portal from './portalReducer';
import alerts from './alertsReducer';
import tickets from './ticketReducer';
import billing from './billingReducer';
import settings from './settingsReducer';
import priceList from './priceListReducer';
import myAccount from './myAccountReducer';
import equipment from './equipmentReducer';
import timesheets from './timesheetsReducer';
import tableOptions from './tableReducer';
import developerAccess from './devAccessReducer';
import inventoryItems from './inventoryItemsReducer';
import invByLocation from './inventoryByLocationReducer';
import inventoryLocations from './inventoryLocationsReducer';
import featureFlagSettings from './featureFlagSettingsReducer';

export default combineReducers({
  router: router5Reducer,
  alerts,
  billing,
  developerAccess,
  equipment,
  priceList,
  inventoryItems,
  inventoryLocations,
  invByLocation,
  myAccount,
  portal,
  settings,
  tableOptions,
  tax,
  tickets,
  timesheets,
  units,
  user,
  featureFlagSettings
});



// WEBPACK FOOTER //
// ./src/reducers/index.js